import { Component, OnDestroy, OnInit } from '@angular/core';
import {UserService} from '@core/services/user.service';
import {NewsService} from '@core/services/news.service';
import { Subscription } from 'rxjs';
import { User } from '@app/shared/models/user';

@Component({
  selector: 'app-news-page-my-news',
  templateUrl: './news-page-my-news.component.html',
  styleUrls: []
})
export class NewsPageMyNewsComponent implements OnInit, OnDestroy {
  userIsLoading = false;
  showUserNews = false;
  userNewsEntries = [];

  loading = false;
  moreUserNewsEntriesAvailable = false;

  userSubscription: Subscription;
  currentUser: User = null;

  constructor(
    private userService: UserService,
    private newsService: NewsService,
  ) { }


  async ngOnInit() {
    this.userSubscription = this.userService.currentUserSubject.subscribe(async user => {
      if (this.currentUser?._id !== user?._id) {
        this.currentUser = user;
        this.userNewsEntries = [];
        this.shouldShowUserNews(user);
        this.loadMoreUserNews();
      }
    })
  }

  private shouldShowUserNews(user: User) {
    this.userIsLoading = true;

    if (this.userService.isLoggedIn() === false) {
      this.showUserNews = false;
      this.userIsLoading = false;
      return;
    }

    if (user.userDoesFollowTeams() === false && user.userDoesFollowLeagues() === false) {
      this.showUserNews = false;
    } else {
      this.showUserNews = true;
    }
    this.userIsLoading = false;
  }

  loadMoreUserNews() {
    if (this.showUserNews === false) {
      return;
    }

    this.loading = true;
    this.newsService.fetchNewsOfUser(this.userNewsEntries.length, 10)
      .then(res => {
        res.entries.forEach(el => {
          this.userNewsEntries.push(el)
        });
        this.moreUserNewsEntriesAvailable = this.userNewsEntries.length < res.total_count;
        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        console.error(err)
      })
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }
}
